import React, {useEffect, useState, Fragment} from 'react'
import { TextField } from '@material-ui/core'
import axios, {AxiosResponse} from 'axios'
import { Autocomplete } from '@mui/material';
import {useLang} from '../../../_metronic/i18n/Metronici18n'


const API_URL = process.env.REACT_APP_API_URL

const headers = {
    'Content-Type': 'application/json',
    'Accept' : 'application/json'
}

const AutocompleteTextForm = (props: any) => {
 	 
 	const lang = useLang()
 	
    const [options, setOptions] = useState([])
    const [values, setValues] = useState<any[]|null>(null)
    
    var alreadyLoadedIds: any = []
    var alreadyOptions: any = []
    
    const setValue = (values_selected: any) => {
	    
	    //TEXT FORMAT FOR VALIDATION RULES (ARRAY => STRING)
	    var newValues: any = []
	    values_selected.forEach((value: any)=>{
		    newValues.push(value.value)
		})
		
		
		window.FormSettings[props.form_name][props.field.name]['value'] = newValues.join(", ")
		props.formikProps.values[props.field.name] = newValues.join(", ")
		
		
    }
    
    const setValueTextOnChange = (event: any) => {
	    
	    var value_texte = setValueText(event.target.value)
	    
	    setValues(value_texte)
	    
	    return value_texte
		
    }
    
    
    const setValueText = (value_texte: any) => {
	    
		window.FormSettings[props.form_name][props.field.name]['value'] = value_texte
		props.formikProps.values[props.field.name] = value_texte
		
		return value_texte
		
    }
    
    
    
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    
    const reloadOptions = (event: any) => {
	    
	    
	    if(event){
			//LOAD ENTITY AUTCOMPLETE BY CONTENT TYPE
			const bundle  = Object.values(window.FormSettings[props.form_name][props.field.name]['bundle']).join("+")
			const target_type  = window.FormSettings[props.form_name][props.field.name]['target_type']
			
			const build_url = API_URL  + "/" + lang + '/autocomplete/' + target_type + "/" + bundle + "?_format=hal+json&filter=" + event.target.value
		
		    axios.get(build_url, {headers})
	            .then((response: AxiosResponse) => {
		            
		            //ADD TEXT SELECTED
		            var new_options = alreadyOptions
		            new_options.push(Object.assign({}, {'label':event.target.value, 'value': event.target.value}));
    
    
		            //ON FUSIONNE AVEC LES OPTIONS DEJA CHARGE (POUR NE PAS PERDRE LES VALEURS INITIALES)
		            response.data.forEach((value: any)=>{
			            
			            value.label = value.label.replace("&amp;", "&")
			            
			            if(typeof value.label_html == "undefined"){
				            value.label_html = value.label
			            }
			            
			            if(alreadyLoadedIds.indexOf(value.value) === -1){
						    alreadyLoadedIds.push(value.value)
							alreadyOptions.push(Object.assign({}, value))
						}
					})
		            
	                //SET STATE OPTIONS
					setOptions(new_options)
					
					//setValueText(event.target.value)
					//setValues(event.target.value)
					
	            });
        }else{
	        setOptions(alreadyOptions)
        }
		
    }
  
 
    //EXTRACT ID
    const formDrupalValues = () => {
	    
	    if(window.FormSettings[props.form_name][props.field.name]['value']){
		    return setValueText(window.FormSettings[props.form_name][props.field.name]['value'])
	    }else if(window.FormSettings[props.form_name][props.field.name]['default_value']){
		    var default_text = window.FormSettings[props.form_name][props.field.name]['default_value']
		    window.FormSettings[props.form_name][props.field.name]['default_value'] = null
		    return setValueText(default_text)
	    }
	    
    }
    
		
    const inputValue = formDrupalValues()
    
    return (
	    <div>
		    <div>
				<Autocomplete
				  //ref={myUncontrolledAutocomplete}
				  disablePortal
				  id={props.element.id ? "auto-" + props.element.id.toString() : ""}
				  options={options}
				  sx={{  }}
				  clearOnBlur={false}
				  className='form-control form-control-solid form-control-lg '
				  value={inputValue}
				  renderInput={(params) => <TextField {...params} label="" 
					  onKeyUp={(event) => {
					      setValueTextOnChange(event)
					      reloadOptions(event)
					  }} 
				  />}
				  onChange={(event, newValue) => {
					if(newValue){
					  	setValueText(newValue.label)
					  	setValues(newValue.label)
				  	}else{
					  	setValueText(null)
					  	setValues(null)
				  	}
				  }}
				/>
			</div>
			
		    
		</div>
    )
 
	
	
	        
}


export default AutocompleteTextForm
